import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { IoClose, IoSave } from "react-icons/io5";
import { API } from "./constant";
import "../CSS/components.css";
import "../CSS/global.css";

const masterTypes = [
    "Category",
    "Licence Type",
    "Status",
    "Hosting Type",
    "Business Function",
    "School Location"
];

const Masters = () => {
    const [masters, setMasters] = useState([]);
    const [selectedType, setSelectedType] = useState(masterTypes[0]);
    
    const [showModal, setShowModal] = useState(false);
    const [editingMaster, setEditingMaster] = useState(null);
    const [formData, setFormData] = useState({ type: masterTypes[0], value: "" });

    const fetchMasters = async () => {
        try {
            const response = await axios.get(`${API}/masters?type=${selectedType}`);
            setMasters(response.data);
        } catch (error) {
            console.error("Error fetching masters:", error);
            if (error.response?.status === 401 || error.response?.data?.message === "Invalid Token") {
                window.location.href = "/";
            } else {
                toast.error("Failed to load master data.");
            }
        }
    };

    useEffect(() => {
        fetchMasters();
    }, [selectedType]);

    const handleOpenModal = (master = null) => {
        if (master) {
            setEditingMaster(master);
            setFormData({ type: master.type, value: master.value });
        } else {
            setEditingMaster(null);
            setFormData({ type: selectedType, value: "" });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setEditingMaster(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingMaster) {
                await axios.put(`${API}/masters/${editingMaster._id}`, formData);
                toast.success("Master record updated successfully");
            } else {
                await axios.post(`${API}/masters`, formData);
                toast.success("Master record added successfully");
            }
            fetchMasters();
            handleCloseModal();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to save master data");
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this master record?")) {
            try {
                await axios.delete(`${API}/masters/${id}`);
                toast.success("Master record deleted successfully");
                fetchMasters();
            } catch (error) {
                toast.error("Failed to delete master record");
            }
        }
    };

    return (
        <div>
            <ToastContainer autoClose={1500} />
            <div className='card_button_container'>
                <div className='button_search DFJCBAIC marginB10'>
                    <div>
                        <h2 className="text-xl font-bold">Master Data Management</h2>
                    </div>
                    <div className='DFJCCAIC gap10'>
                        <div>
                            <select 
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                                className="search_box w-48 border rounded p-2"
                                style={{marginRight: '10px'}}
                            >
                                {masterTypes.map(t => (
                                    <option key={t} value={t}>{t}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <button onClick={() => handleOpenModal()} className='add_button'>Add {selectedType}</button>
                        </div>
                    </div>
                </div>

                <hr />

                <div className='table_container width100 mt-4'>
                    <table className="mac_table">
                        <thead>
                            <tr>
                                <th>Sl. No.</th>
                                <th>Type</th>
                                <th>Value</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {masters.map((master, index) => (
                                <tr key={master._id}>
                                    <td>{index + 1}</td>
                                    <td>{master.type}</td>
                                    <td>{master.value}</td>
                                    <td>
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => handleOpenModal(master)}
                                                className="edit_btn"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete(master._id)}
                                                className="delete_btn text-red-500 font-bold"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {masters.length === 0 && (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>
                                        No entries found for {selectedType}.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {showModal && (
                    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
                        <div className="bg-white w-[400px] rounded-xl shadow-2xl overflow-hidden flex flex-col">
                            <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
                                <h2 className="text-lg font-bold text-gray-800">
                                    {editingMaster ? "Edit Master Record" : "Add Master Record"}
                                </h2>
                                <IoClose size={24} className="cursor-pointer hover:text-red-500" onClick={handleCloseModal} />
                            </div>

                            <form onSubmit={handleSubmit} className="p-6">
                                <div className="space-y-4">
                                    <div className="form_group">
                                        <label>Master Type</label>
                                        <input 
                                            type="text" 
                                            value={formData.type} 
                                            disabled 
                                            readOnly
                                            className="w-full border rounded p-2 bg-gray-100 cursor-not-allowed" 
                                        />
                                    </div>
                                    <div className="form_group">
                                        <label>Value*</label>
                                        <input 
                                            type="text" 
                                            required
                                            value={formData.value} 
                                            onChange={(e) => setFormData({...formData, value: e.target.value})} 
                                            className="w-full border rounded p-2" 
                                            placeholder="Enter value"
                                        />
                                    </div>
                                </div>

                                <div className="mt-6 flex justify-end gap-2">
                                    <button type="button" onClick={handleCloseModal} className="px-4 py-2 text-gray-500 hover:underline">Cancel</button>
                                    <button
                                        type="submit"
                                        className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded font-bold hover:bg-blue-700 shadow-lg"
                                    >
                                        <IoSave /> Save
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Masters;